(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement-bar"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('vallorne-announcement-countdown')) {
    customElements.define('vallorne-announcement-countdown', class extends HTMLElement {
      connectedCallback() {
        this.endTime = Date.parse(this.dataset.end || '');
        if (!Number.isFinite(this.endTime)) {
          this.hidden = true;
          return;
        }

        this.values = {
          days: this.querySelector('[data-countdown-value="days"]'),
          hours: this.querySelector('[data-countdown-value="hours"]'),
          minutes: this.querySelector('[data-countdown-value="minutes"]'),
          seconds: this.querySelector('[data-countdown-value="seconds"]')
        };
        this.units = this.querySelector('.vallorne-announcement-countdown__units');
        this.accessible = this.querySelector('[data-countdown-accessible]');
        this.expired = this.querySelector('[data-countdown-expired]');
        this.tick = this.tick.bind(this);
        this.tick();
      }

      disconnectedCallback() {
        window.clearTimeout(this.timer);
      }

      format(value) {
        return String(value).padStart(2, '0');
      }

      tick() {
        const remaining = this.endTime - Date.now();
        if (remaining <= 0) {
          this.finish();
          return;
        }

        const days = Math.floor(remaining / 86400000);
        const hours = Math.floor((remaining % 86400000) / 3600000);
        const minutes = Math.floor((remaining % 3600000) / 60000);
        const seconds = Math.floor((remaining % 60000) / 1000);

        this.values.days.textContent = this.format(days);
        this.values.hours.textContent = this.format(hours);
        this.values.minutes.textContent = this.format(minutes);
        this.values.seconds.textContent = this.format(seconds);
        this.accessible.textContent = `${days} days, ${hours} hours, ${minutes} minutes, ${seconds} seconds`;
        this.timer = window.setTimeout(this.tick, 1000 - (Date.now() % 1000));
      }

      finish() {
        window.clearTimeout(this.timer);
        if (this.dataset.hideWhenExpired === 'true') {
          this.closest('[data-vallorne-announcement]')?.setAttribute('hidden', '');
          return;
        }
        if (this.units) this.units.hidden = true;
        if (this.expired) {
          this.expired.textContent = this.dataset.expiredMessage || '';
          this.expired.hidden = false;
        }
        if (this.accessible) this.accessible.textContent = this.dataset.expiredMessage || '';
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vallorne-featured-works-hero"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('vallorne-shop-tabs')) {
    customElements.define('vallorne-shop-tabs', class extends HTMLElement {
      connectedCallback() {
        if (this.dataset.ready) return;
        this.tabs = [...this.querySelectorAll('[role="tab"]')];
        this.panels = [...this.querySelectorAll('[data-shop-panel]')];
        if (!this.tabs.length) return;
        this.tabs.forEach((tab,index) => {
          tab.addEventListener('click',() => this.select(index));
          tab.addEventListener('keydown',event => {
            let next = index;
            if (event.key === 'ArrowRight') next = (index + 1) % this.tabs.length;
            else if (event.key === 'ArrowLeft') next = (index - 1 + this.tabs.length) % this.tabs.length;
            else if (event.key === 'Home') next = 0;
            else if (event.key === 'End') next = this.tabs.length - 1;
            else return;
            event.preventDefault();
            this.select(next);
            this.tabs[next].focus({preventScroll:true});
            this.tabs[next].scrollIntoView({block:'nearest',inline:'nearest',behavior:'instant'});
          });
        });
        this.select(0);
        this.querySelector('[role="tablist"]').hidden = false;
        this.dataset.ready = 'true';
        if (this.dataset.chooseLabel) {
          this.querySelectorAll('modal-opener .quick-add__submit').forEach(button => {
            const label = [...button.childNodes].find(node => node.nodeType === Node.TEXT_NODE && node.textContent.trim());
            if (label) label.textContent = this.dataset.chooseLabel;
          });
        }
      }
      select(index) {
        this.tabs.forEach((tab,i) => {
          tab.setAttribute('aria-selected',String(i === index));
          tab.tabIndex = i === index ? 0 : -1;
        });
        this.panels.forEach(panel => { panel.hidden = panel.id !== this.tabs[index].getAttribute('aria-controls'); });
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vallorne-newsletter-popup"]) return;
  try {
    
  if (!customElements.get('vallorne-newsletter-popup')) {
    customElements.define('vallorne-newsletter-popup', class extends HTMLElement {
      connectedCallback() {
        if (this.dataset.initialized === 'true') return;
        this.dataset.initialized = 'true';
        this.dialog = this.querySelector('dialog');
        this.closeButton = this.querySelector('[data-popup-close]');
        this.copyButton = this.querySelector('[data-popup-copy]');
        this.codeField = this.querySelector('[data-popup-code]');
        this.storageKey = `vallorne-newsletter-popup:${this.dataset.storageVersion || '1'}`;
        this.formState = this.querySelector('[data-popup-success]') ? 'success' : this.querySelector('[data-popup-error]') ? 'error' : 'idle';
        this.onScroll = this.onScroll.bind(this);
        this.mobileQuery = window.matchMedia('(max-width: 749px)');
        this.onViewportChange = () => this.scheduleAutoOpen();

        this.querySelector('[data-popup-open]')?.addEventListener('click', () => this.open(true));
        this.closeButton?.addEventListener('click', () => this.dialog?.close());
        this.dialog?.addEventListener('click', (event) => {
          if (event.target === this.dialog) this.dialog.close();
        });
        this.copyButton?.addEventListener('click', () => this.copyCode());

        if (this.formState === 'success') {
          this.writeState({ status: 'subscribed', timestamp: Date.now() });
          window.setTimeout(() => this.open(), 80);
          return;
        }

        if (this.formState === 'error') {
          window.setTimeout(() => this.open(), 80);
          return;
        }

        if (window.Shopify?.designMode) {
          if (this.dataset.previewInEditor === 'true') window.setTimeout(() => this.open(), 250);
          document.addEventListener('shopify:section:select', (event) => {
            if (event.detail.sectionId === this.dataset.sectionId) this.open();
          });
          return;
        }

        if (this.dataset.manualOnly === 'true' || this.isMobileAutoBlocked()) return;

        const state = this.readState();
        const returnDays = Math.max(1, Number(this.dataset.returnDays) || 14);
        if (state?.status === 'subscribed') return;
        if (state?.trigger === 'pdp-10s-v33' && state?.timestamp && Date.now() - state.timestamp < returnDays * 86400000) return;

        this.autoStartedAt = Date.now() - Math.min(performance.now(), 10000);
        this.autoEligible = true;
        this.mobileQuery.addEventListener('change', this.onViewportChange);
        this.scheduleAutoOpen();
        if ((Number(this.dataset.scroll) || 0) > 0) window.addEventListener('scroll', this.onScroll, { passive: true });
      }

      disconnectedCallback() {
        this.autoEligible = false;
        this.clearAutoTriggers();
      }

      clearAutoTriggers() {
        window.clearTimeout(this.delayTimer);
        window.removeEventListener('scroll', this.onScroll);
        this.mobileQuery?.removeEventListener('change', this.onViewportChange);
      }

      scheduleAutoOpen() {
        window.clearTimeout(this.delayTimer);
        if (!this.autoEligible || this.isMobileAutoBlocked()) return;
        const seconds = this.mobileQuery.matches
          ? Math.max(0, Number(this.dataset.mobileDelay) || 5)
          : Math.max(0, Number(this.dataset.delay) || 5);
        const remaining = Math.max(0, seconds * 1000 - (Date.now() - this.autoStartedAt));
        this.delayTimer = window.setTimeout(() => this.open(), remaining);
      }

      readState() {
        try {
          return JSON.parse(window.localStorage.getItem(this.storageKey));
        } catch (error) {
          return null;
        }
      }

      writeState(value) {
        try {
          window.localStorage.setItem(this.storageKey, JSON.stringify(value));
        } catch (error) {
          return;
        }
      }

      onScroll() {
        if (this.mobileQuery.matches) return;
        const scrollable = document.documentElement.scrollHeight - window.innerHeight;
        if (scrollable <= 0) return;
        const progress = window.scrollY / scrollable * 100;
        if (progress >= (Number(this.dataset.scroll) || 0)) this.open();
      }

      isMobileAutoBlocked() {
        return this.formState === 'idle' && !window.Shopify?.designMode &&
          this.dataset.autoShowMobile !== 'true' && this.mobileQuery.matches;
      }

      open(manual = false) {
        if (!this.dialog || this.dialog.open || (!manual && this.isMobileAutoBlocked())) return;
        if (!manual && this.formState === 'idle' && !window.Shopify?.designMode) {
          if (!this.autoEligible) return;
          const mobileDelay = Math.max(0, Number(this.dataset.mobileDelay) || 5) * 1000;
          if (this.mobileQuery.matches && Date.now() - this.autoStartedAt < mobileDelay) {
            this.scheduleAutoOpen();
            return;
          }
        }
        if (!manual && this.formState === 'idle' && (document.hidden || document.querySelector('dialog[open], cart-drawer.active'))) {
          this.delayTimer = window.setTimeout(() => this.open(), 1500);
          return;
        }
        this.autoEligible = false;
        this.clearAutoTriggers();
        if (this.formState === 'idle' && !window.Shopify?.designMode) {
          if (this.readState()?.status !== 'subscribed') this.writeState({ status: 'shown', timestamp: Date.now(), trigger: 'pdp-10s-v33' });
        }
        this.dialog.showModal();
      }

      async copyCode() {
        if (!this.codeField || !this.copyButton) return;
        try {
          await navigator.clipboard.writeText(this.codeField.value);
        } catch (error) {
          this.codeField.select();
          document.execCommand('copy');
          window.getSelection()?.removeAllRanges();
        }
        this.copyButton.textContent = this.copyButton.dataset.copiedLabel || this.copyButton.dataset.copyLabel;
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
